module.exports = __webpack_public_path__ + "_assets/img/profile-05.7c758b17.svg";